<template>
    <div>
        <form>
            <b-form-row>
                <b-form-group class="col-md-3" label="Fecha desde *" >
                    <b-form-datepicker 
                        locale="es" 
                        :class="{'active-filter':filters.startDate}" 
                        reset-button size="sm" 
                        v-model="filters.startDate"/>
                </b-form-group>

                <b-form-group class="col-md-3" label="Hasta *" >
                    <b-form-datepicker 
                        locale="es" 
                        :class="{'active-filter':filters.endDate}" 
                        reset-button  
                        size="sm" 
                        v-model="filters.endDate"/>
                </b-form-group>

                <b-form-group>
                    <b-button 
                        class="mt-4"
                        variant="outline-primary" 
                        type="button" 
                        @click="checkform()">
                        <md-icon icon="search"/>
                    </b-button>
                </b-form-group>
            </b-form-row>
        </form>

        <!-- Botones de navegacion-->
        <div class="text-right">
            Por página:
            <b-form-select
                size="sm"
                style="width: 80px;"
                class="mb-2 mr-2"
                v-model="filters.pagination.perPage"
                :options="perPageOpts"
                @change="search"
            ></b-form-select>

            <b-button 
                v-if="filters.pagination.currentPage > 0"
                class="mb-2 mr-2" 
                variant="primary"   
                type="button"
                size="sm" 
                @click="prevPage()">Anterior</b-button>

            <b-button 
                v-if="incidents.hasNextPage == true"
                class="mb-2" 
                variant="primary"   
                type="button"
                size="sm" 
                @click="nextPage()">Siguiente</b-button>
        </div>

        <!-- Loading -->
        <div v-if="loading" class="col-12 text-center pt-5">
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
        </div>
        <!-- End Loading -->

        <b-table  
            v-if="!loading"
            show-empty
            hover
            striped
            bordered
            small
            :items="table.body"
            :fields="table.header"
            responsive
            id="incidents-table">

            <template #cell(index)="row">
                {{ row.index + 1 }}
            </template>

            <template #cell(bookingReference)="row">
                <strong>{{ row.item.bookingReference }}</strong>
            </template>

            <template #cell(incidentType)="row">
                <b-badge
                    variant="secondary"
                    class="ml-1">
                    {{ row.item.incidentType }}
                </b-badge>
            </template>

            <template #cell(incidentStatus)="row">
                <b-badge
                    v-if="row.item.incidentStatus == 'RESOLVED'"
                    variant="info"
                    class="ml-1">
                    {{ row.item.incidentStatus }}
                </b-badge>

                <b-badge
                    v-if="row.item.incidentStatus == 'DISPUTED'"
                    variant="warning"
                    class="ml-1">
                    {{ row.item.incidentStatus }}
                </b-badge>
            </template>

            <template #cell(responsibleParty)="row">
                <b-badge
                    v-if="row.item.responsibleParty != 'SUPPLIER'"
                    variant="secondary"
                    class="ml-1">
                    {{ row.item.responsibleParty }}
                </b-badge>

                <b-badge
                    v-if="row.item.responsibleParty == 'SUPPLIER'"
                    variant="danger"
                    class="ml-1">
                    {{ row.item.responsibleParty }}
                </b-badge>
            </template>


            <template #cell(createdDateTimeUTC)="row">
                {{ showLocalTime(row.item.createdDateTimeUTC) }}
            </template>
            <template #cell(modifiedDateTimeUTC)="row">
                {{ showLocalTime(row.item.modifiedDateTimeUTC) }}
            </template>
            <template #cell(pickupDateTimeUTC)="row">
                {{ showLocalTime(row.item.pickupDateTimeUTC) }}
            </template>
        </b-table>
        

        <!-- Botones de navegacion-->
        <div class="text-right">
            <b-button 
                v-if="filters.pagination.currentPage > 0"
                class="mb-2 mr-2" 
                variant="primary"   
                type="button"
                size="sm" 
                @click="prevPage()">Anterior</b-button>

            <b-button 
                v-if="incidents.hasNextPage == true"
                class="mb-2" 
                variant="primary"   
                type="button"
                size="sm" 
                @click="nextPage()">Siguiente</b-button>
        </div>
    </div>
</template>

<script>

import moment from 'moment'
import api from "../../../../api.js";
export default {
    name: "booking-incidents",
    components: {},
    data() {

        let start = moment().startOf('month').format('YYYY-MM-DD');
        let end   = moment().format('YYYY-MM-DD');

        return {
			loading: false,
			codeReport: "booking-incidents",
			filters: {
				startDate: start,
				endDate: end,
                pagination: {
                    currentPage: 0,
                    perPage: 10
                },
			},
            perPageOpts: [10,50,100,500],
			table:{
				body:[],
				header:[
                    { key: 'index', label: '#' },
                    { key: 'bookingReference',    label: 'Referencia' },
                    { key: 'incidentType',        label: 'Incidente' },
                    { key: 'incidentStatus',      label: 'Estatus' },
                    { key: 'responsibleParty',    label: 'Parte Responsable' },
                    { key: 'createdDateTimeUTC',  label: 'Creado' },
                    { key: 'modifiedDateTimeUTC', label: 'Modificado' },
                    { key: 'pickupDateTimeUTC',   label: 'Pickup DateTime' },
                    
                ]
			},
            incidents: []
        }
    },
    methods: {
        checkform() {
            let errors = [];
            if (this.filters.startDate === "" || this.filters.endDate === "") {
                errors.push("Fecha inicio y fecha fin son requeridos");
            }

            if (this.filters.dateCriteria === "") {
                errors.push("Criterio fechas es requerido");
            }

            if (errors.length === 0) {
                this.search();
            } else {
                this.$root.showAlert(errors[0],{variant:'warning'});
            }
        },
        search() {
            this.loading       = true;
			this.showHtmlTable = false;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters
					}
				})
				.then(res => {
                    if (res.data.errorCode) {
                        console.error(res.data.errorMessage)
                        return false
                    } 
					this.table.body = res.data.incidents
                    this.incidents = res.data
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loading = false;
				}); 
        },
        showLocalTime(date) {
            const format = new Date(date+"Z")            
            return format.toLocaleString()
        },
        prevPage() {
            this.filters.pagination = {
                currentPage: this.incidents.currentPage - 1,
                perPage: this.filters.pagination.perPage
            }

            this.search()
        },
        nextPage() {
            this.filters.pagination = {
                currentPage: this.incidents.currentPage + 1,
                perPage: this.filters.pagination.perPage
            }

            this.search()
        }
    }
}

</script>